module.exports = __webpack_public_path__ + "images/emoji/arrow_up_small.5f701dcbd331040991fe.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_up_small.png
// module id = i9hs
// module chunks = 2